import { call, put } from "redux-saga/effects";

import { apiGeneral, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginateCarrierResponsibleEmailActions } from "store/ducks/settings/carrier-responsible-email";

export function* paginateCarrierResponsibleEmailRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/carrier-responsible-email?${queryString}`
    );

    const { carrierResponsibleEmails, pagination } = responseBody;
    yield put(
      PaginateCarrierResponsibleEmailActions.success(
        carrierResponsibleEmails,
        pagination
      )
    );
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginateCarrierResponsibleEmailActions.failure(errorMessage));
  }
}
